'use strict';

var module = angular.module('doclr.components.adminagendacomponents');

function toDate(dateStr, timeStr) {
    const [year, month, day] = dateStr.split('-');
    const [hour, minutes] = timeStr.split(':');
    return new Date(year, month - 1, day, hour, minutes);
}

function afspraakToekomst(event) {
    let today = new Date();
    let eventDate = toDate(event.dag, event.van);
    return (today - eventDate) <= 0;
}

module.controller('afspraakMogelijkheidPopoverController', function ($scope, $state, slicesService, userContext) {
    $scope.viewModel = {};
    $scope.viewModel.selectedType = $scope.afspraakTypes.findTypeVoorId($scope.event.typeId);
    $scope.availableAfspraakTypes = $scope.afspraakTypes.filter(type => type.isActive || ($scope.viewModel.selectedType && $scope.viewModel.selectedType.id === type.id))
    $scope.userContext = userContext;
    $scope.isTelesecretariaat = userContext.isTeleSecretariaat();
    $scope.showPopupPast = function (event) {
        var today = new Date();
        var eventDate = toDate(event.dag, event.van);
        if (today - eventDate > 0) {
            return userContext.isTeleSecretariaat();
        } else {
            return false;
        }
    };

    $scope.$watch('viewModel.selectedType', function (newValue, oldValue) {

        if (newValue === oldValue) {
            return;
        }
        if (newValue.zichtbaar_voor_patient === 'nee') {
            $scope.vrijgaveStrategie = null;
            $scope.vrijgaveGroep = null;
            $scope.vrijgaveVolgnummer = null;
        }
    });

    $scope.verwijder = function () {
        $scope.event.verwijder().then(function () {
            slicesService.reload();
            $scope.dismiss();
        });
    };

    $scope.save = function () {
        var eventCopy = angular.copy($scope.event);
        eventCopy.typeId = $scope.viewModel.selectedType.id;
        eventCopy.saveWijzigingen().then(function () {
            slicesService.reload();
            $scope.dismiss();
        });
    };

    $scope.maakAfspraak = function () {
        $scope.dismiss();
        $state.go('.afspraakdetail', {
            dagClicked: $scope.event.dag,
            uur: $scope.event.van,
            agenda: encodeURIComponent($scope.event.agendaId),
            duur: $scope.event.duur,
            typeId: $scope.viewModel.selectedType.id
        });
    };
});

module.controller('afspraakPopoverController', function ($scope, $state, moveService, slicesService, praktijkContext
    , Afspraken
    , printer
    , userContext
    , praktijkAfgewerkt
    , AppointmentLocationProvider
    , notificationService
    , DoclrModalService
    , customForms
) {
    $scope.userContext = userContext;
    $scope.praktijkContext = praktijkContext;
    $scope.praktijkAfgewerkt = praktijkAfgewerkt;
    $scope.isTelesecretariaat = userContext.isTeleSecretariaat();
    $scope.customForm = customForms[$scope.event.typeId];
    $scope.showPopupPast = function (event) {
        var today = new Date();
        var eventDate = toDate(event.dag, event.van);
        if (today - eventDate > 0) {
            return $scope.isTelesecretariaat;
        } else {
            return false;
        }
    };

    $scope.verwijder = function () {
        if ($scope.event.recurrenteAfspraakId) {
            $scope.dismiss();
            $scope.event.checkRecurringAppointmentDelete()
                .then((recurringDeleteResponse) => {
                        if (recurringDeleteResponse.data.nbOfNextAppointments === 0) {
                            applyDelete();
                        } else {
                            DoclrModalService.openOptionModal(doclrVertaal.instant('recurrent.appointment.delete.title'),
                                doclrVertaal.instant('recurrent.appointment.delete.question'),
                                [{display: doclrVertaal.instant('recurrent.appointment.delete.current'), value: 'current'},
                                    {
                                        display: doclrVertaal.instant('recurrent.appointment.delete.allNext') + '(' + recurringDeleteResponse.data.nbOfNextAppointments + ')',
                                        value: 'allNext'
                                    }],
                                "current"
                            )
                                .then((result) => {
                                    if (result === "current") {
                                        applyDelete();
                                    }

                                    if (result === "allNext") {
                                        applyDeleteWithNextRecurringAppointments();
                                    }
                                })
                        }
                    }
                )
        } else {
            applyDelete();
        }

        function applyDeleteWithNextRecurringAppointments() {
            $scope.event.deleteWithNextRecurringAppointments().then(function () {
                $scope.$emit('afspraak.gewijzigd', doclrVertaal.instant("afspraak.gewijzigd"), $scope.event);
                slicesService.reload();
                $scope.dismiss();
            });
        }

        function applyDelete() {
            $scope.event.verwijder().then(function () {
                $scope.$emit('afspraak.gewijzigd', doclrVertaal.instant("afspraak.gewijzigd"), $scope.event);
                slicesService.reload();
                $scope.dismiss();
            });
        }


    };

    $scope.undoVerwijder = function () {
        $scope.event.undoVerwijder().then(function () {
            slicesService.reload();
            $scope.dismiss();
        });
    };

    $scope.verberg = function () {
        $scope.event.verberg().then(function () {
            slicesService.reload();
            $scope.dismiss();
        });
    };

    $scope.wijzig = function () {
        $state.go('.afspraakdetail', {afspraakId: encodeURIComponent($scope.event.id)});
    };

    $scope.wijzigAanwezig = function () {
        var afspraak = $scope.event;
        afspraak.zetAanwezig(afspraak.aanwezig);
        $scope.dismiss();
    };

    $scope.wijzigInTreatment = function () {
        var afspraak = $scope.event;
        afspraak.zetInTreatment(afspraak.inTreatment);
        if (afspraak.inTreatment) {
            notificationService.showSuccess(doclrVertaal.instant('De persoon werd in behandeling gezet'));
        } else {
            notificationService.showSuccess(doclrVertaal.instant('De persoon werd uit behandeling gezet'));
        }
        $scope.dismiss();
    };

    $scope.move = function () {
        moveService.start($scope.event, false);
        $scope.dismiss();
    };

    $scope.copy = function () {
        moveService.start($scope.event, true);
        $scope.dismiss();
    };

    $scope.print = function () {
        var afspraak = $scope.event;
        var afspraakId = afspraak.id.split('/').pop();

        Afspraken.getAfspraak(afspraakId).then(function (afspraakDetail) {
            let location = AppointmentLocationProvider.getLocation(praktijkContext, afspraakDetail.typeId);
            printer.printAfspraak(afspraakDetail, praktijkContext, location);
        });
    };

    $scope.copyToClipboard = function () {
        $scope.$emit('afspraak.gekopieerd', doclrVertaal.instant('afspraak.gekopieerd'), $scope.event);
        $scope.dismiss();
    };
});

module.controller('momentPopoverController', function ($scope, slicesService, $state, Absences) {
    $scope.verwijder = function () {
        if ($scope.event.isPartyAbsence) {
            Absences.deletePartyAbsence($scope.event.beschikbaarheidId)
                .then(function () {
                    slicesService.reload();
                    $scope.dismiss();
                });
        } else {
            $scope.event.verwijder().then(function () {
                slicesService.reload();
                $scope.dismiss();
            });
        }
    };

    $scope.wijzig = function () {
        if ($scope.event.eventType === 'afwezigheid' && $scope.event.beschikbaarheidId) {
            $state.go('.afwezigheid', {
                absenceId: $scope.event.beschikbaarheidId,
                isPartyAbsence: $scope.event.isPartyAbsence,
                calendarId: $scope.event.agendaUuid
            })
        }
    };
});

module.controller('afspraakVrijgavePopoverController', function ($scope, $state, slicesService) {

    $scope.availabilityReleaseStrategy = new AvailabilityReleaseStrategy($scope.event.availabilityReleaseStrategy);

    $scope.onReleaseStrategyConfirmed = function (strategy) {

        var eventCopy = angular.copy($scope.event);
        eventCopy.availabilityReleaseStrategy = strategy;
        eventCopy.saveWijzigingen().then(function () {
            slicesService.reload();
            $scope.dismiss();
        });
    }
});

module.controller('afspraakZoekenController', function ($scope, $state, $filter, Afspraken, praktijkContext, slicesService, openAppointmentService) {
    $scope.haalAfsprakenOp = function (query) {
        return Afspraken.zoeken(query, praktijkContext.id);
    };

    $scope.selecteerAfspraak = function (appointment) {
        openAppointmentService.openAppointment(appointment.id, true);
        $scope.afspraak.selectedAfspraak = undefined;
    };
});